"use strict";

PF.Calendar = class Calendar extends PF.Widget
	{
	static get options()
		{
		return {
			html: PF.Calendar.templates,
			locale: 'ru',

			monthClass: PF.Calendar.Month,
			weekClass: PF.Calendar.Week,
			dayClass: PF.Calendar.Day,
		};
		}

	static get templates()
		{
		return {
			//language=HTML
			wrapper: `
			 <div class="pf-calendar-wrapper">
				 <div class="fab fab-right-bottom">
					 <a href="#" pf="toToday">
						 <i class="material-icons">today</i>
					 </a>
				 </div>

				 <div class="pf-calendar-body" pf="body"></div>
			 </div>
			`
		};
		}

	init()
		{
		this.dom.loads(this.html);
		this.dom.element.addClass('pf-calendar');
		this.dom.element.append(this.dom.wrapper);

		this.months = new PF.Models();
		this.monthsList = new PF.Dom.List({
			dom: {element: this.dom.body},
			models: this.months,
			itemClass: this.monthClass,
			calendar: this,
			enableDummy: false,
		});
		this.rebuild(DateTime.local());
		this.dom.body.on('scroll', () => this.scrollSlot());

		this.dom.toToday.on('click', () => this.scrollToDate(DateTime.local()));
		this.bindDom({toToday: 'hide'}, 'today.dom.item.inView');
		}

	scrollSlot()
		{
		if (this.dom.body.node.scrollTop > this.dom.body.node.scrollHeight - 2 * this.dom.body.height())
			{
			let start = this.months[this.months.length - 1].start.plus({months: 1}).startOf('month');
			let finish = start.plus({months: 3}).endOf('month');
			this.computeDates(start, finish, 'append');
			console.log('append');
			}
		if (this.dom.body.node.scrollTop < 2 * this.dom.body.height())
			{
			let finish = this.months[0].start.minus({months: 1}).endOf('month');
			let start = finish.minus({months: 3}).startOf('month');
			this.computeDates(start, finish, 'prepend');
			console.log('prepend');
			}
		}


	computeDates(start, finish, splice = 'append')
		{
		let currentDay = new DateTime(start);
		let pastDay = new DateTime(start);
		let month, week;
		let months = [];
		do
			{
			if (month === undefined || pastDay.month !== currentDay.month)
				{
				month = new PF.Model({raw: {start: new DateTime(currentDay), weeks: []}});
				months.push(month);
				week = new PF.Model({raw: {start: new DateTime(currentDay), days: []}});
				month.weeks.push(week);
				}
			else if (pastDay.weekNumber !== currentDay.weekNumber)
				{
				week = new PF.Model({raw: {start: new DateTime(currentDay), days: []}});
				month.weeks.push(week);
				}
			let day = new PF.Model({raw: {day: new DateTime(currentDay)}});
			week.days.push(day);
			pastDay = new DateTime(currentDay);
			currentDay = currentDay.plus({days: 1});
			}
		while (currentDay < finish);
		if (splice === 'append')
			{
			this.months.splice(this.months.length, 0, ...months);
			}
		else
			{
			this.months.splice(0, 0, ...months);
			}
		this.trigger('rebuildFinish');
		}

	rebuild(center)
		{
		this.trigger('rebuildStart');
		this.months.splice(0, this.months.length);
		let start = center.minus({months: 2}).startOf('month');
		let finish = center.plus({months: 2}).endOf('month');

		this.computeDates(start, finish);
		this.trigger('rebuildFinish');

		// this.dom.element.scrollToNode(this.today.dom.item);
		this.scrollToDate(center);
		}

	rebuildDiapason(start, finish)
		{
		this.trigger('rebuildStart');
		this.months.splice(0, this.months.length);
		let start1 = start.minus({months: 3}).startOf('month');
		let finish1 = finish.plus({months: 3}).endOf('month');

		this.computeDates(start1, finish1);
		this.trigger('rebuildFinish');

		// this.dom.element.scrollToNode(this.today.dom.item);
		this.scrollToDate(start);
		}

	scrollToDate(date)
		{
		let day = this.findDay(date);
		this.scrollToDay(day);
		}

	findDay(date)
		{
		if (date === null)
			{
			return undefined;
			}
		let month = undefined;
		if (typeof date === 'string')
			{
			date = Util.fromDbDate(date);
			}
		for (let i = 0; i < this.monthsList.length; i++)
			{
			if (this.monthsList[i].model.start.hasSame(date, 'month'))
				{
				month = this.monthsList[i];
				break;
				}
			}
		if (month === undefined)
			{
			return;
			}
		let week;
		for (let i = 0; i < month.weeks.length; i++)
			{
			if (month.weeks[i].model.start.hasSame(date, 'week'))
				{
				week = month.weeks[i];
				break;
				}
			}
		for (let i = 0; i < week.days.length; i++)
			{
			if (week.days[i].model.day.hasSame(date, 'day'))
				{
				return week.days[i];
				}
			}
		return undefined;
		}

	scrollToDay(day)
		{
		if (day !== undefined)
			{
			this.dom.body.scrollToNode(day.dom.item, 'center');
			}
		}

	scrollToDate(date)
		{
		let day = this.findDay(date);
		if (day !== undefined)
			{
			this.scrollToDay(day);
			}
		else
			{
			this.rebuild(date);
			}
		}


	};

PF.Calendar.Month = class Month extends PF.Dom.List.Item
	{
	get renderer()
		{
		//language=HTML
		return `
			<div class="pf-calendar-month">
				<div class="month-name">${this.name}</div>
				<div class="pf-calendar-month-wrapper" pf="month">
				</div>
			</div>
		`;
		}

	get name()
		{
		let year = this.model.start.hasSame(DateTime.local(), 'year') ? '' : ' ' + this.model.start.year;
		return app.locale.monthNames[this.model.start.month] + year;
		}

	onRender()
		{
		// super.onRender();
		this.weeks = new PF.Dom.List({
			dom: {element: this.dom.month},
			models: this.model.weeks,
			itemClass: this.list.calendar.weekClass,
			calendar: this.list.calendar,
			month: this,
			enableDummy: false,
		});


		// this.on('weeks.*.days.change:size', () => {
		// 	console.log(this.model.weeks[this.model.weeks.length - 1].days.length);
		// 	if (this.model.weeks[this.model.weeks.length - 1].days.length !== 7)
		// 		{
		// 		this.dom.item.setHeight(((this.model.weeks.length - 1) * 3) + "em");
		// 		}
		// });
		// this.list.calendar.on('rebuildStart', () => this.pauseEvent('weeks.*.days.change:size'));
		this.on('list.calendar.rebuildFinish', () => {
			// console.log(this.model.weeks[this.model.weeks.length - 1].days.length);
			if (this.model.weeks[this.model.weeks.length - 1].days.length !== 7)
				{
				this.dom.item.setHeight(((this.model.weeks.length - 1) * 3) + "em");
				}
		});
		}

	destroy()
		{
		this.weeks.destroy();
		super.destroy();
		}
	};


PF.Calendar.Week = class Week extends PF.Dom.List.Item
	{
	get renderer()
		{
		//language=HTML
		return `
		  <div class="pf-calendar-week" pf="week"></div>
		`;
		}


	onRender()
		{
		// super.onRender();
		this.days = new PF.Dom.List({
			dom: {element: this.dom.week},
			models: this.model.days,
			itemClass: this.list.calendar.dayClass,
			calendar: this.list.calendar,
			week: this,
			enableDummy: false
		});
		}

	destroy()
		{
		this.days.destroy();
		super.destroy();
		}
	};


PF.Calendar.Day = class Day extends PF.Dom.List.Item
	{
	get renderer()
		{
		//language=HTML
		return `
			<div class="pf-calendar-day">${this.number}</div>
		`;
		}

	get number()
		{
		return this.model.day.day;
		}

	onRender()
		{
		// super.onRender();
		// this.dom.item.bindObject(this);

		// this.dom.day.node.innerHTML = ;

		if (this.model.day.hasSame(DateTime.local(), 'day'))
			{
			this.dom.item.bindClasses();
			this.dom.item.classes.today = this.model.day.hasSame(DateTime.local(), 'day');

			this.list.week.list.month.list.calendar.today = this;
			this.today = true;
			this.list.calendar.dom.body.bindInView(this.dom.item, 'part');

			this.destroy = () => {
				this.list.calendar.dom.body.unBindInView(this.dom.item);
				this.list.week.list.month.list.calendar.today = undefined;
				super.destroy();
			};
			// this.dom.item.bindInView(this.list.calendar.dom.body, 'part');
			// this.dom.item.onValue('inView', true);
			}
		}

	};
